import { lazy } from 'react'
import type { RouteObject } from 'react-router'
import { page } from '@/shared/ui'

const OwnerHomePage = lazy(() => import('@/roles/owner/pages/OwnerHomePage'))
const MyStorePage = lazy(() => import('@/roles/owner/pages/MyStorePage'))
const MyStoreChangePage = lazy(() => import('@/roles/owner/pages/MyStoreChangePage'))
const NoticePage = lazy(() => import('@/roles/owner/pages/NoticePage'))
const LegalDocsPage = lazy(() => import('@/roles/owner/pages/LegalDocsPage'))

/** OwnerShell 안에 그려지는 화면 — `/owner` 기준 상대 경로 */
export const ownerRoutes: RouteObject[] = [
  { path: 'home', element: page(OwnerHomePage) },
  { path: 'mystore', element: page(MyStorePage) },
  { path: 'mystore/change', element: page(MyStoreChangePage) },
  { path: 'notice/:noticeId?', element: page(NoticePage) },
  { path: 'docs/:docType?', element: page(LegalDocsPage) },
]
